import React from 'react'
import TopCollectorsItem from './TopCollectorsItem'
import { Link } from 'react-router-dom'

function TopCollectors( { title, subtitle, viewPage }) {
    return (
        <div className="singleMarketMove">
            <div className="itemHeading">
                <h3 className="left"> { title } </h3>
                <p><small className="right"> {subtitle} </small></p>
            </div>
            <TopCollectorsItem
                userPath = "/user/username"
                userProfileThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                userName = "@username"
                COLLECTED = {19}
            />
            <TopCollectorsItem
                userPath = "/user/username"
                userProfileThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                userName = "@username"
                COLLECTED = {15}
            />
            <TopCollectorsItem
                userPath = "/user/username"
                userProfileThumb = "https://ipfs.pixura.io/ipfs/QmSSeq2KkBhhVjUNQsTfM9u8xrSuLSDCJmwKJ731pbyEVr/flower_water-wallpaper-1920x1080.jpg"
                userName = "@username"
                COLLECTED = {12}
            />
            <Link to={viewPage} className="itemFootOpt">See All</Link>
        </div>
    )
}

export default TopCollectors
